var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebBrowser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.23,163V55.72a4.82,4.82,0,0,1,4.69-4.94H178.43a4.82,4.82,0,0,1,4.69,4.94V163Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.24,
    y1: 81.25,
    x2: 183.11,
    y2: 81.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.27,65.44a3.06,3.06,0,1,1-3.06-3,3,3,0,0,1,3.06,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.06,65.44a3.06,3.06,0,1,1-3.06-3,3,3,0,0,1,3.06,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.85,65.44a3.06,3.06,0,1,1-3.06-3,3,3,0,0,1,3.06,3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebBrowser);
export default __webpack_public_path__ + "static/media/WEB_BROWSER.00ddbf78ebf2bbf8d5afa4df92f0f5c9.svg";
export { ForwardRef as ReactComponent };